const Body = ({ renderField, name }) => renderField(name);

export default Body;
